const
  NAME               = 'adverDisplacement',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

const
  AUTO = 'auto',
  MARGIN = 400
;

class AdverDisplacement {
  constructor(element$, options) {
    if (element$.parent().height() <= element$.height()) {return;}

    this._element$ = element$;

    if (element$.data('voc-adver-displacement') === AUTO) {
      element$.one('vam:slotrendered', this.onRendered.bind(this));
    }

    element$.stick_in_parent(options);
  }

  onRendered() {
    this._element$.parent().height(this._element$.height() + MARGIN);
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(options) {
    return this.each(function() {
      new AdverDisplacement($(this), options);
    });
  }
}

$.fn[NAME]             = AdverDisplacement._jQueryInterface;
$.fn[NAME].Constructor = AdverDisplacement;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return AdverDisplacement._jQueryInterface;
};

export default AdverDisplacement;




// WEBPACK FOOTER //
// ./src/plugins/adver-displacement.js